import axios from 'axios';

interface ICheckReceiptDoneResponse {
    is_valid: boolean;  // 可申请完成
    message: string;
}

export default {
    // 获取当前回执是否可申请完成（子项目全部完成）
    getCheckReceiptDone(auditId: string): Promise<ICheckReceiptDoneResponse> {
        return axios.get<ICheckReceiptDoneResponse>(`/api/audits/${auditId}/check-receipt-done`).then(res => {
            return res.data;
        });
    }
}